import React from "react";
import { FaFileAlt, FaUserTie, FaComments, FaLightbulb } from "react-icons/fa";

const supportFeatures = [
  {
    icon: <FaFileAlt />,
    title: "Resume Building",
    desc: "We help you craft a professional and impactful resume tailored for your field.",
  },
  {
    icon: <FaUserTie />,
    title: "Mock Interviews",
    desc: "Practice one-on-one technical and HR interviews with real-time feedback.",
  },
  {
    icon: <FaComments />,
    title: "Personalized Feedback",
    desc: "Get insights and improvement tips from our mentors after every mock session.",
  },
  {
    icon: <FaLightbulb />,
    title: "Career Guidance",
    desc: "Explore career paths, trending tools, and placement opportunities in your domain.",
  },
];

const ResumeSupport = () => {
  return (
    <section className="bg-white py-20 px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-sky-700 mb-6">
          Resume & Interview Support
        </h2>
        <p className="text-gray-600 mb-12 max-w-2xl mx-auto">
          We don't just train you — we prepare you for the real world.
          From building a standout resume to acing interviews, we support you at every step.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {supportFeatures.map((feature, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 bg-gray-50 rounded-lg shadow-md p-6 hover:shadow-xl transition"
            >
              <div className="text-sky-600 text-3xl">{feature.icon}</div>
              <div className="text-left">
                <h3 className="text-lg font-semibold mb-1">{feature.title}</h3>
                <p className="text-gray-600 text-sm">{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResumeSupport;
